import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';

const CosmicRings = ({ audioData, vibeConfig }) => {
  const ring1Ref = useRef();
  const ring2Ref = useRef();
  const ring3Ref = useRef();
  
  const { colors } = vibeConfig || {};

  useFrame((state) => {
    if (!audioData) return;

    const time = state.clock.getElapsedTime();
    
    // Ring 1 - Bass responsive
    if (ring1Ref.current) {
      ring1Ref.current.rotation.z = time * 0.3 + audioData.bass * 2;
      const scale1 = 1 + audioData.bass * 2;
      ring1Ref.current.scale.setScalar(scale1);
    }
    
    // Ring 2 - Mid responsive
    if (ring2Ref.current) {
      ring2Ref.current.rotation.z = -time * 0.5 + audioData.mid * 3;
      ring2Ref.current.rotation.x = time * 0.2;
      const scale2 = 1 + audioData.mid * 1.5;
      ring2Ref.current.scale.setScalar(scale2);
    }
    
    // Ring 3 - Treble responsive
    if (ring3Ref.current) {
      ring3Ref.current.rotation.z = time * 0.8 + audioData.treble * 4;
      ring3Ref.current.rotation.y = time * 0.3;
      const scale3 = 1 + audioData.treble * 2.5;
      ring3Ref.current.scale.setScalar(scale3);
    }
  });

  const primaryColor = colors?.primary || '#00ffff';
  const secondaryColor = colors?.secondary || '#ff0080';
  const accentColor = colors?.accent || '#8000ff';

  return (
    <group>
      {/* Outer ring - Bass */}
      <mesh ref={ring1Ref} rotation={[Math.PI / 2, 0, 0]}>
        <torusGeometry args={[6, 0.15, 16, 64]} />
        <meshStandardMaterial 
          color={primaryColor}
          transparent
          opacity={audioData ? 0.4 + audioData.bass * 0.4 : 0.4}
          emissive={primaryColor}
          emissiveIntensity={audioData ? 0.2 + audioData.bass * 0.3 : 0.2}
          roughness={0.2}
          metalness={0.8}
        />
      </mesh>

      {/* Middle ring - Mid */}
      <mesh ref={ring2Ref} rotation={[Math.PI / 3, 0, 0]}>
        <torusGeometry args={[4.5, 0.1, 12, 48]} />
        <meshStandardMaterial 
          color={secondaryColor}
          transparent
          opacity={audioData ? 0.5 + audioData.mid * 0.3 : 0.5}
          emissive={secondaryColor}
          emissiveIntensity={audioData ? 0.3 + audioData.mid * 0.4 : 0.3}
          roughness={0.1}
          metalness={0.9}
        />
      </mesh>

      {/* Inner ring - Treble */}
      <mesh ref={ring3Ref} rotation={[Math.PI / 6, 0, 0]}>
        <torusGeometry args={[3, 0.08, 8, 32]} />
        <meshStandardMaterial 
          color={accentColor}
          transparent
          opacity={audioData ? 0.6 + audioData.treble * 0.4 : 0.6}
          emissive={accentColor}
          emissiveIntensity={audioData ? 0.4 + audioData.treble * 0.6 : 0.4}
          roughness={0.05}
          metalness={1.0}
        />
      </mesh>
    </group>
  );
};

export default CosmicRings;